import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { IInstructionDetails } from "../../../api/Instruction";
import EpaCard from "../../../leap-components/EpaCard";
import EpaField from "../../../leap-components/EpaField";
import EpaFieldHtml from "../../../leap-components/EpaFieldHtml";
import { GetLicenseeReturnPageUrl } from "../../routeFactory";

interface InstructionDetailsProps {
  instruction: IInstructionDetails;
}

const InstructionDetails = ({ instruction }: InstructionDetailsProps) => {
  const linkToLicenseeReturn = GetLicenseeReturnPageUrl(
    instruction.profileNo,
    instruction.licenseesubmissionid
  );
  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Date Submitted by the EPA"}
            value={instruction.datesubmitted}
          />
          <EpaField label={"Subject"} value={instruction.subject} />
        </Col>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Related Licensee Return"}
            value={
              <Link to={linkToLicenseeReturn}>
                {instruction.licenseeReturn?.reference}
              </Link>
            }
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12">
          <EpaFieldHtml
            label={"Correspondence from EPA"}
            value={instruction.licensingnotification}
            labelClassName={"col-12 col-md-12"}
            valueClassName={"col-12 col-md-12"}
          />
        </Col>
      </Row>
    </div>
  ) as JSX.Element;

  return (
    <EpaCard
      title={"Licensee Return Instructions Details"}
      content={bodyElements}
    />
  );
};

export default InstructionDetails;
